import styles from '@hts/entities/Card/styles/InfoContent/AddMusic/AddMusic.module.scss';
import { useAudioPlayerStore } from '@hts/shared/libs/zustand';
import { ICardAudioItemInput } from '@hts/shared/types';
import { HtsButton, HtslIcon, HtsTypography } from '@hts/shared/ui';
import { memo, useCallback, useState } from 'react';
import { SelectMusicPopup } from './SelectMusicPopup';

interface IAddMusicProps {
  resendCard: boolean;
  musicPrice: number;
}

export const AddMusic: React.FC<IAddMusicProps> = memo(({ resendCard, musicPrice }) => {
  const [open, setOpen] = useState(false);
  const [checkedSong, setCheckedSong] = useState<ICardAudioItemInput | null>(null);

  const { setActiveSong } = useAudioPlayerStore();

  const onClickButton = useCallback(() => {
    const nextState = !open;

    if (!nextState) {
      setActiveSong(undefined);
    }

    setOpen(nextState);
  }, [open]);

  const onClosePopup = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <div className={styles.container} style={{ maxWidth: resendCard ? '100%' : 426 }}>
      <SelectMusicPopup
        open={open}
        checkedSong={checkedSong}
        resendCard={resendCard}
        setCheckedSong={setCheckedSong}
        onClose={onClosePopup}
      />

      <HtsButton
        label="Add music"
        variant="outlined"
        fullWidth
        className={styles.button}
        typographyProps={{ variant: 'body2', style: { whiteSpace: 'nowrap' } }}
        leftContent={<HtslIcon icon="melody" color="primaryDark" style={{ minWidth: 14 }} />}
        captionContent={
          checkedSong && (
            <HtsTypography element="span" variant="caption" style={{ width: '100%' }}>
              Selected -{' '}
              <HtsTypography element="span" variant="caption" color="primaryDark">
                {checkedSong.name}
              </HtsTypography>
            </HtsTypography>
          )
        }
        rightContent={
          <span className={styles.rightAddContent}>
            <HtsTypography element="span" variant="body2">
              +${musicPrice}
            </HtsTypography>

            <span className={styles.rightActionIcon}>
              <span className={`${styles.plusIcon} ${open ? styles.plusIconOpen : ''}`}>
                <HtslIcon icon="plus" color="white" />
              </span>
            </span>
          </span>
        }
        onClick={onClickButton}
      />
    </div>
  );
});
